module.exports = __webpack_public_path__ + "media/images/badges/yogasix/february/HeartBadges-23-ceb0bc2e76643c962db4d17b3a45d96a.png";